<template>
  <div class="four-step-plan__grid">
    <div class="four-step-plan__step" v-for="step in steps.slice(0, show)" :key="step.step">
      <div class="four-step-plan__step-content">
        <p class="four-step-plan__number">0{{ step.step }}</p>
        <p class="four-step-plan__title">{{ step.title }}</p>
        <p class="four-step-plan__description">{{ step.description }}</p>
      </div>
      <img class="four-step-plan__image" :src="step.image" />
    </div>
  </div>
</template>

<script setup lang="ts">
import started1 from 'app/assets/images/home/started_1.webp'
import started2 from 'app/assets/images/home/started_2.webp'
import started3 from 'app/assets/images/home/started_3.webp'
import started4 from 'app/assets/images/home/started_4.webp'

const { show = 4 } = defineProps<{ show?: number }>()

const steps: {
  step: number
  title: string
  description: string
  image: string
}[] = [
  {
    step: 1,
    title: 'Create your personalized itinerary instantly',
    description: 'Start with your trip ideas and instantly turn them into a custom itinerary.',
    image: started1,
  },
  {
    step: 2,
    title: 'See real-time pricing as you edit your itinerary',
    description: 'Make changes to your trip live and see price updates on the spot.',
    image: started2,
  },
  {
    step: 3,
    title: 'Get local expert help to perfect your trip',
    description: 'Local experts who operate the trip help fine-tune the details of your itinerary.',
    image: started3,
  },
  {
    step: 4,
    title: 'Publish your trip, enjoy the journey, and earn',
    description: 'We handle logistics—just enjoy your trip and start earning.',
    image: started4,
  },
]
</script>

<style lang="scss" scoped>
.four-step-plan__grid {
  gap: 20px;
  img {
    border-radius: 15px;
    width: 100%;
  }

  @include desktop {
    display: grid;
    grid-auto-flow: column;
  }

  @include mobile {
    display: flex;
    flex-direction: column;
    justify-items: center;
    margin: 0 var(--site-px);

    img {
      height: 190px;
      width: calc(100% - 10px);
    }
  }
}

.four-step-plan__step {
  @include flex-column;

  gap: 10px;
  height: 100%;
  border-left: 1px solid $gray-lighter;
  padding-left: 10px;
}

@include desktop {
  .four-step-plan__step-content {
    flex: 1;
  }
}

.four-step-plan__number {
  margin: 0 0 30px 0;
  line-height: 1;
  font-size: $text-4xl;
  background: -webkit-linear-gradient(270deg, #1c355e 14.34%, #538c97 85.42%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.four-step-plan__title {
  font-weight: 600;
}

.four-step-plan__description {
  font-size: $text-base;
  font-weight: 400;
}

.four-step-plan__image {
  height: 300px;
}
</style>
